import { Avatar, ButtonGroup, SkeletonText, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import ButtonRemoveResource from 'components/ButtonRemoveResource';
import ActiveTag from 'components/ui/ActiveTag';
import ButtonEdit from 'components/ui/ButtonEdit';
import DateTime from 'components/ui/DateTime';
import EmptyList from 'components/ui/EmptyList';
import Pagination from 'components/ui/Pagination';
import UserRoleTag from 'components/ui/UserRole/UserRoleTag';
import { UserRoleType } from 'components/ui/UserRole/user-role.enum';
import { useServerDynamicTableContext } from 'contexts/server-table/ServerDynamicTableContext';
import { useLocation } from 'react-router-dom';

export default function UsersList() {
  const location = useLocation();
  const { table, queryResult } = useServerDynamicTableContext();
  const users = queryResult?.data?.items || [];
  const total = queryResult?.data?.meta?.total || 0;
  const isLoading = queryResult?.isLoading || false;

  const hasData = total > 0;
  const hasResult = table.getRowModel().rows.length > 0;

  return (
    <SkeletonText isLoaded={!isLoading}>
      {hasResult && (
        <>
          <TableContainer>
            <Table mt="25px">
              <Thead>
                <Tr>
                  <Th>Nome</Th>
                  <Th>E-mail</Th>
                  <Th>Status</Th>
                  <Th>Tipo de perfil</Th>
                  <Th>Cadastrado em</Th>
                  <Th w="120px"></Th>
                </Tr>
              </Thead>
              <Tbody>
                {users.map((user) => (
                  <Tr key={`user-${user.id}`}>
                    <Td>
                      <Avatar
                        size="sm"
                        bgColor="bg.avatar"
                        name={user.name}
                      />
                      {user.name}
                    </Td>
                    <Td>{user.email}</Td>
                    <Td>
                      <ActiveTag isActive={user.active} />
                    </Td>
                    <Td>
                      <UserRoleTag role={user.role as UserRoleType} />
                    </Td>
                    <Td>
                      <DateTime date={user.createdAt} />
                    </Td>
                    <Td textAlign="right">
                      <ButtonGroup>
                        <ButtonEdit
                          to={{
                            pathname: `/usuarios/${user.id}`,
                            search: location.search,
                          }}
                        />
                        <ButtonRemoveResource
                          id={user.id}
                          pathName="users"
                          queryKey="users"
                        />
                      </ButtonGroup>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
          <Pagination table={table} />
        </>
      )}

      {(!hasData || !hasResult) && (
        <EmptyList
          mt="25px"
          title={
            !hasData
              ? 'Você ainda não possui nenhum usuário cadastrado'
              : 'Nenhum resultado encontrado'
          }
          description=""
          isTable
        />
      )}
    </SkeletonText>
  )
}
